import { createSlice } from "@reduxjs/toolkit";

let initialState = {
  ticketType: "Flights",
  ticketFilterType: "Bookings",
  ticketStatusType: "All",
  flightStatusFilterValues: [],
  ticketStatusFilterValues: [],
  ticketSearchValue: "",
  ticketsPage: 1,
  ticketsPerPage: 10,
  ticketsSortHeader: null,
  selectedTicketsSortHeader: { index: 0, type: "desc", name: "Order Number" },
  tourOrders: [],
  hotelOrders: [],
  flightOrders: [],
  insuranceOrders: [],
  packageOrders: [],
  esimOrders: [],
  voidOrders: [],
  refundOrders: [],
  reissueOrders: [],
  renameOrders: [],
  openTicketOrders: [],
  hotelTotal: 0,
  tourTotal: 0,
  insuranceTotal: 0,
  packageTotal: 0,
  esimTotal: 0,
};

export const order = createSlice({
  name: "order",
  initialState,
  reducers: {
    setTicketType: (state, action) => {
      state.ticketType = action.payload;
    },
    setTicketFilterType: (state, action) => {
      state.ticketFilterType = action.payload;
    },
    setTicketStatusType: (state, action) => {
      state.ticketStatusType = action.payload;
    },
    setFlightStatusFilterValues: (state, action) => {
      state.flightStatusFilterValues = action.payload;
    },
    setTicketStatusFilterValues: (state, action) => {
      state.ticketStatusFilterValues = action.payload;
    },
    setTicketSearchValue: (state, action) => {
      state.ticketSearchValue = action.payload;
    },
    setTicketsPage: (state, action) => {
      state.ticketsPage = action.payload;
    },
    setTicketsPerPage: (state, action) => {
      state.ticketsPerPage = action.payload;
    },
    setTicketsSortHeader: (state, action) => {
      state.ticketsSortHeader = action.payload;
    },
    setSelectedTicketsSortHeader: (state, action) => {
      state.selectedTicketsSortHeader = action.payload;
    },
    setFlightOrders: (state, action) => {
      state.flightOrders = action.payload;
    },
    setHotelOrders: (state, action) => {
      state.hotelOrders = action.payload;
    },
    setTourOrders: (state, action) => {
      state.tourOrders = action.payload;
    },
    setInsuranceOrders: (state, action) => {
      state.insuranceOrders = action.payload;
    },
    setPackageOrders: (state, action) => {
      state.packageOrders = action.payload;
    },
    setEsimOrders: (state, action) => {
      state.esimOrders = action.payload;
    },
    setVoidOrders: (state, action) => {
      state.voidOrders = action.payload;
    },
    setRefundOrders: (state, action) => {
      state.refundOrders = action.payload;
    },
    setReissueOrders: (state, action) => {
      state.reissueOrders = action.payload;
    },
    setRenameOrders: (state, action) => {
      state.renameOrders = action.payload;
    },
    setOpenTicketOrders: (state, action) => {
      state.openTicketOrders = action.payload;
    },
    setHotelOrderTotal: (state, action) => {
      state.hotelTotal = action.payload;
    },
    setTourOrderTotal: (state, action) => {
      state.tourTotal = action.payload;
    },
    setInsuranceOrderTotal: (state, action) => {
      state.insuranceTotal = action.payload;
    },
    setPackageOrderTotal: (state, action) => {
      state.packageTotal = action.payload;
    },
    setEsimOrderTotal: (state, action) => {
      state.esimTotal = action.payload;
    },
  },
});

export const {
  setTicketType,
  setTicketFilterType,
  setTicketSearchValue,
  setTicketStatusType,
  setFlightStatusFilterValues,
  setTicketStatusFilterValues,
  setTicketsPage,
  setTicketsPerPage,
  setTicketsSortHeader,
  setSelectedTicketsSortHeader,
  setHotelOrders,
  setTourOrders,
  setFlightOrders,
  setVoidOrders,
  setRefundOrders,
  setReissueOrders,
  setRenameOrders,
  setOpenTicketOrders,
  setInsuranceOrders,
  setHotelOrderTotal,
  setTourOrderTotal,
  setInsuranceOrderTotal,
  setPackageOrders,
  setPackageOrderTotal,
  setEsimOrders,
  setEsimOrderTotal,
} = order.actions;

export default order.reducer;
